// src/utils/textCover.js

/**
 * Capa DESENHADA do texto — a que aparece quando não há imagem enviada.
 *
 * Mora aqui, e não dentro de um componente, porque duas telas mostram a mesma
 * capa do mesmo texto: a estante (TextCardsForm.vue) e o painel de metadados do
 * leitor (TextDisplayer.vue). Se cada uma tivesse a sua tabela de paletas, o
 * mesmo texto poderia aparecer azul num lugar e vermelho no outro — e nada
 * acusaria o erro, porque as duas continuariam "funcionando".
 *
 * O complemento disto é o `utils/coverImage.js`, que prepara a capa ENVIADA.
 */

/**
 * O hash do TÍTULO escolhe a paleta, e não o id: assim a capa é a mesma toda
 * vez que o texto aparece, em qualquer máquina, e não muda se a numeração
 * mudar. É a mesma técnica dos chips de assunto do dashboard.
 */
export const COVER_PALETTES = [
  ["#1e3a8a", "#3b82f6"],
  ["#134e4a", "#0d9488"],
  ["#7c2d12", "#ea580c"],
  ["#4c1d95", "#8b5cf6"],
  ["#7f1d1d", "#dc2626"],
  ["#164e63", "#0891b2"],
  ["#365314", "#65a30d"],
  ["#831843", "#db2777"],
  ["#1c1917", "#57534e"],
  ["#312e81", "#6366f1"],
];

export function hashString(value) {
  const s = String(value ?? "");
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

/** Gradiente da capa desenhada, derivado do título. */
export function coverStyle(text) {
  const [from, to] =
    COVER_PALETTES[hashString(text?.title) % COVER_PALETTES.length];
  return { backgroundImage: `linear-gradient(160deg, ${from} 0%, ${to} 100%)` };
}

/**
 * Número do tombo, no espírito da etiqueta de acervo: o id com zeros à
 * esquerda. Serve também de âncora visual quando o título é longo e some no
 * clamp.
 */
export function coverTombo(text) {
  return String(text?.textId ?? "").padStart(6, "0");
}
